import React from "react";
import StaffMemberListTemplate from "./StaffMemberListTemplate";

export default function StaffMemberListView() {

        return <StaffMemberListTemplate/>

}